import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { conformToMask } from 'react-text-mask';
import {
  FiBriefcase,
  FiUser,
  FiPlusCircle,
  FiTrash2,
  FiEdit2,
} from 'react-icons/fi';

import {
  logOut, setProducerData, removeProducerData, removeProducer,
} from '../../../../../support/store/AuthReducer';
import { SpaceService } from '../../../../../support/services/api';
import EditUserData from './EditUserData';
import AddOnlyConsumingProducer from './AddOnlyConsumingProducer';
import './styles.css';
import { Header, ProcessButton } from '../../../../components';


function Confirm({
  email, firstName, setFirstName, lastName, setLastName, whatsapp, setWhatsapp, cpf, setCpf, setStep,
}) {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState('user');
  const [showForm, setShowForm] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const producers = useSelector((state) => state.AuthReducer.userData.producers);

  const onLogout = () => {
    dispatch(logOut());
    setStep(1);
  };

  const leavePage = async () => {
    if (selected.includes('producer')) await dispatch(setProducerData(producers[Number(selected.replace('producer', ''))]));
    else await dispatch(removeProducerData());

    const nextPath = location.state?.nextPath;
    if (nextPath && nextPath !== '' && nextPath !== undefined) history.push(nextPath); // TODO: check if is valid path
  };

  const deleteProducer = async (producer) => {
    await SpaceService().remove(producer.id);
    await dispatch(removeProducer(producer));
  };

  if (showForm) {
    return {
      pf: <EditUserData
        email={email}
        firstName={firstName}
        setFirstName={setFirstName}
        lastName={lastName}
        setLastName={setLastName}
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        cpf={cpf}
        setCpf={setCpf}
        setStep={setStep}
        setShowForm={setShowForm}
      />,
      pj: <AddOnlyConsumingProducer
        setShowForm={setShowForm}
      />,
    }[showForm];
  }

  return (
    <div className="confirm-container">
      <section className="confirm-container">
        <Header goBack={() => setStep(1)} />
        <h1 className="title">
          Em nome de quem será feito o pedido?
        </h1>
        <div className="options-group">
          <button
            type="button"
            className={`option-button ${selected === 'user' ? 'option-selected' : ''}`}
            onClick={() => setSelected('user')}
          >
            <div className="option-icon">
              <FiUser size={32} strokeWidth="0.8" />
            </div>
            <div className="option-text">
              <h2>
                {firstName}
                {' '}
                {lastName}
              </h2>
              <div className="data">
                <p className="identity-type">
                  Pessoa Física
                </p>
                <p>{email}</p>
                <p>
                  {
                    conformToMask(
                      whatsapp.substring(3,14),
                      ['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
                    ).conformedValue
                  }
                </p>
              </div>
            </div>
            <FiEdit2 size={24} strokeWidth="1" className="edit-icon" onClick={() => setShowForm('pf')} />
          </button>
          <button className="clickable-label" onClick={onLogout} type="button">
            Não é você?
          </button>
          <div className="divisory-line-PJ" />
          {producers?.length
            ? producers.map((producer, index) => (
              <button
                key={index}
                type="button"
                className={`option-button ${selected === `producer${String(index)}` ? 'option-selected' : ''}`}
                onClick={() => setSelected(`producer${String(index)}`)}
              >
                <div className="option-icon">
                  <FiBriefcase size={32} strokeWidth="0.8" />
                </div>
                <div className="option-text">
                  <h2>{producer.name ?? producer.register.producerName ?? producer.register.companyName}</h2>
                  <div className="data">
                    <p className="identity-type">Pessoa Jurídica</p>
                    <p>
                      { producer.register?.cnpj
                        && conformToMask(
                          producer.register.cnpj,
                          [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/],
                        ).conformedValue}
                    </p>
                  </div>
                </div>
                {producer.status !== 'active'
                  ? <FiTrash2 size={24} strokeWidth="1" className="del-icon" onClick={() => deleteProducer(producer)} />
                  : <div style={{ width: 24 }} />}
              </button>
            ))
            : (
              <p className="orientation">
                Para pedir em nome de uma
                <span className="clickable-label"> empresa</span>
                , clique no botão abaixo
              </p>
            )}
        </div>
        <button className="plus-button" onClick={() => setShowForm('pj')} type="button">
          <FiPlusCircle size={42} strokeWidth="0.8" color="#888" />
        </button>
      </section>
      <ProcessButton text="Prosseguir com o pedido" action={() => leavePage()} />
    </div>
  );
}

export default Confirm;
